exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_widgets_2DnUC0fp57b6Ut76gRvrqU {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_1SWud-WB8KdB_AFwwqav04 {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_tPUE4tyvix9g8I1GKLUot {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_qkFbarbvua6ToXPfosz2I {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_widgets": "IA_widgets_2DnUC0fp57b6Ut76gRvrqU",
	"IA_filters": "IA_filters_1SWud-WB8KdB_AFwwqav04",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_tPUE4tyvix9g8I1GKLUot",
	"IA_paginationPageCount": "IA_paginationPageCount_qkFbarbvua6ToXPfosz2I"
};